import { PropsLink } from './PropsLink';
import { useAppSelector } from '@redux/hooks';
import { ensureTrailingSlash } from '@sharedHelpers/ensureTrailingSlash';
import classNames from 'classnames';
import Link from 'next/link';
import IconShortArrow from './short-arrow.svg';
import IconArrow from './arrow.svg';

import styles from './Link.module.scss';

export const MyLink = ({
  href = '',
  children,
  color = 'red',
  appearance,
  className,
  target,
  disabled,
  appendTrailingSlash,
  ...props
}: PropsLink): JSX.Element => {
  const subdomain = useAppSelector(state => state.header.data.region?.SUBDOMAIN);
  const LinkIndexRobot = (href: string): boolean => {
    if (subdomain) {
      const linkRegexp = /https:\/\/.+[^koleso.ru].+\./;
      return linkRegexp.test(href.replace(`${subdomain}.`, ''));
    } else {
      return false;
    }
  };

  const finalUrl = ensureTrailingSlash(href, appendTrailingSlash);

  const isReload = href.includes('/catalog/') || href.includes('auto');

  if (isReload) {
    return (
      <a
        href={finalUrl}
        target={target}
        rel={LinkIndexRobot(finalUrl) ? 'nofollow' : null}
        className={classNames(styles.Link, styles[appearance], styles[color], disabled && styles.disabled, className)}
        {...props}
      >
        {appearance === 'theme5' && <IconArrow />}
        {children}
        {appearance === 'theme3' && <IconShortArrow />}
      </a>
    );
  }

  return (
    <Link href={finalUrl}>
      <a
        target={target}
        rel={LinkIndexRobot(finalUrl) ? 'nofollow' : null}
        className={classNames(styles.Link, styles[appearance], styles[color], disabled && styles.disabled, className)}
        {...props}
      >
        {appearance === 'theme5' && <IconArrow />}
        {children}
        {appearance === 'theme3' && <IconShortArrow />}
      </a>
    </Link>
  );
};
